import template from './loansSignUp.html';
import controller from './loansSignUp.controller';
import './loansSignUp.scss';

let loansSignUpComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<',
    onClick: '&'
  },
  template,
  controller,
};

export default loansSignUpComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUp.component.js